// SW COLLAPSE ITEM - Accordion (shared)
// Used by: main-collection-grouped, accordion-metaobjects, related-products (AJAX injected).
// Loaded once, globally, from layout/theme.liquid (deferred, after jQuery).
function hideAllSwCollapseItem( excludeObj )
{
  $('.sw-collapse-item__header').each(function() {
      if( $(excludeObj).attr('id') != $(this).attr('id') )
      {
        $(this).siblings('.sw-collapse-item__wrap').hide(); // show hide
        $(this).removeClass("is-active");
        // SVG - Does not work with toogle Class
        $(this).find("svg").attr("class", 'lucide-icon' );
      }
  });
}

// Opens the first `count` .sw-collapse-item elements found within `scope`.
// Used on initial page load, and can be called again after AJAX-injected
// accordion markup (e.g. related products) is added to the page.
// Items inside a ".sw-collapse--no-autoopen" wrapper are skipped (e.g. accordion-metaobjects).
function openSwCollapseItems( scope, count )
{
  var $scope = scope ? $(scope) : $(document);
  count = count || 2;

  var $items = $scope.find('.sw-collapse-item').filter(function() {
    return $(this).closest('.sw-collapse--no-autoopen').length === 0;
  });

  $items.each(function(index)
  {
    if (index < count) {

      $(this).find('.sw-collapse-item__header')
          .addClass('is-active')
          .find('svg')
          .attr('class', 'lucide-icon is-active');

      $(this).find('.sw-collapse-item__wrap').show();
    }
  });

  if (typeof window.equalizeVariantRowFillNames === 'function') {
    window.equalizeVariantRowFillNames();
  }
  if (typeof window.equalizeProductCardNames === 'function') {
    window.equalizeProductCardNames();
  }
}
window.openSwCollapseItems = openSwCollapseItems;

$(document).ready(function()
{
  // On page load, open first 2 items
  openSwCollapseItems(document, 2);

  $('#main-content').on('click', '.sw-collapse-item__header', function(e)
  {
    // Edit link
    var edit_link = $(e.target).closest(".edit-link");
    if (edit_link.length) {
        e.preventDefault();   // stops the href="#collapseShipment"
        e.stopPropagation();  // stops bubbling to parent
        var editlink_id = $(edit_link).attr('id');
        var editlink_link = $(edit_link).attr('link');
        if( editlink_link )
        {
          window.location.href = editlink_link;
          return false; // <- extra insurance for Safari
        }
    }

    var item__header = $(this);
    var item__wrap = item__header.siblings('.sw-collapse-item__wrap');
    item__wrap.slideToggle('slow', function() {
      if (typeof window.equalizeVariantRowFillNames === 'function') {
        window.equalizeVariantRowFillNames();
      }
      if (typeof window.equalizeProductCardNames === 'function') {
        window.equalizeProductCardNames();
      }
    }); // show hide
    // item__header.siblings('.sw-collapse-item__wrap').toggle(); // show hide
    item__header.toggleClass("is-active");
    // SVG - Does not work with toogle Class
    item__header.find("svg").attr("class", ( item__header.hasClass("is-active") ? "lucide-icon is-active" : "lucide-icon" ) );

    hideAllSwCollapseItem( item__header );

    var win_width = $(window).width();
    var win_height = $(window).height();

    setTimeout(function() {

      // NEW
      var item__wrap__height = $(item__wrap).height();
      var reqr__height = win_height - item__wrap__height + 100;
      // ~ S - 22Sep2025 - If Negative it means its already more then window, footer will display wrong place
      if( reqr__height > 0 )
      {
        $('#main-content').css( { marginBottom : reqr__height + "px" });
      }

      if (!item__header.hasClass('no-scroll')) {
        $('html, body').animate({
            scrollTop: $("#" + $(item__header).attr('id')).offset().top + (win_width < 992 ? -70 : -180), left:0
        }, 100);
      }
    }, 300);

  });

});